import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime, money } from '../../utils/helpers';
import { isPerUnit } from '../services/useServices';
import '../../styles/money.css';

const statusChip = (s) => s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend';

// Desktop "My Work" — the owner's own engagements as a table per event.
export default function MyWorkDesktop({ vm }) {
  const { byEvent, rows, totals, loading, mapsHref } = vm;

  if (loading) return <div className="card card-pad"><Spinner /></div>;

  return (
    <div>
      <div className="page-head">
        <h1>My Work</h1>
        <span className="muted">{rows.length}</span>
      </div>

      {rows.length === 0 ? (
        <div className="card card-pad empty">Nothing assigned yet. When the organiser books you for a function it appears here.</div>
      ) : (
        <>
          <div className="mn-tiles">
            <div className="mn-tile"><span>Agreed</span><strong>{money(totals.total)}</strong></div>
            <div className="mn-tile ok"><span>Received</span><strong>{money(totals.paid)}</strong></div>
            <div className="mn-tile due"><span>Pending</span><strong>{money(totals.balance)}</strong></div>
          </div>

          {byEvent.map(ev => (
            <div key={ev.EventId} style={{ marginBottom: 14 }}>
              <div className="step-label">{ev.EventName}</div>
              <div className="card table-wrap">
                <table className="tbl compact">
                  <thead>
                    <tr>
                      <th className="grow">Function</th><th>Service</th><th>Date</th><th>Time</th><th>Venue</th>
                      <th className="num">Count</th><th className="mn-r">Agreed</th><th className="mn-r">Received</th>
                      <th className="mn-r">Pending</th><th>Status</th><th></th>
                    </tr>
                  </thead>
                  <tbody>
                    {ev.items.map(row => {
                      const maps = mapsHref(row);
                      return (
                        <tr key={row.ServiceId}>
                          <td className="grow"><strong>{row.FunctionName || 'Whole event'}</strong></td>
                          <td>{row.ServiceType}</td>
                          <td>{fmtDate(row.FunctionDate || row.ServiceDate)}</td>
                          <td>{fmtTime(row.StartTime || row.FunctionStartTime)}
                            {(row.EndTime || row.FunctionEndTime) ? ` – ${fmtTime(row.EndTime || row.FunctionEndTime)}` : ''}</td>
                          <td>
                            {[row.Venue, row.City].filter(Boolean).join(', ') || '—'}
                            {maps && <div className="sub"><a href={maps} target="_blank" rel="noreferrer">Open in Maps</a></div>}
                          </td>
                          <td className="num">{isPerUnit(row.RateType) ? row.ConfirmedCount : '—'}</td>
                          <td className="mn-r">{money(row.TotalAmount)}</td>
                          <td className="mn-r">{money(row.AdvancePaid)}</td>
                          <td className={'mn-r' + (Number(row.BalanceAmount) > 0 ? ' mn-due' : '')}><strong>{money(row.BalanceAmount)}</strong></td>
                          <td><span className={statusChip(row.Status)}>{row.Status}</span></td>
                          <td style={{ textAlign: 'right' }}>
                            <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Menu / jobs</Link>
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
